<div class="chart">
    <canvas id="canvas">{{chart}}</canvas>
</div>